import { TResolvedVersion } from '../types';
import { resolveFileUrl } from '.';

/**
 * Create script element
 * @param loadId
 * @param version
 * @param isAsync
 * @param isDeferred
 * @param baseUrl
 * @param file
 */
export const createScriptElement = (
    loadId: string,
    version: TResolvedVersion,
    isAsync = true,
    isDeferred = false,
    baseUrl: string,
    file?: string
): HTMLElementTagNameMap['script'] => {
    const script = document.createElement('script');

    script.id = loadId;
    script.src = resolveFileUrl(baseUrl, version, file);
    script.async = isAsync;
    script.defer = isDeferred;

    return script;
};
